import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import React from "react";
import { SVGAsset } from "res";

export default function NoAutopayWidget(props) {
  return (
    <WidgetView className="empty">
      <WidgetMainContentView>
        <SVGAsset id="UpsellIcon" className="blue-icon logo set-width" />
        <span className="sub-text">You have no active autopay's to show here.</span>
      </WidgetMainContentView>
    </WidgetView>
  );
}